<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'drawName',
              { rules: [{ required: true, message: '请输入名称,限制15个字' }] },
            ]"
            placeholder="请输入名称"
          />
        </a-form-item>
        <a-form-item label="简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            type="text"
            :max-length="200"
            rows="3"
            v-decorator="['drawDescribe']"
            placeholder="请输入描述,限制200字"
          />
        </a-form-item>
        <a-form-item
          label="活动渠道"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            placeholder="请选择活动渠道"
            v-decorator="[
              'channelType',
              { rules: [{ required: true, message: '请选择活动渠道' }] },
            ]"
            :triggerChange="true"
            dictCode="activity_channel_type"
          />
        </a-form-item>
        <a-form-item label="图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <UploadImage
            @handleFileList="handleImageList"
            v-decorator="['drawImage']"
          />
        </a-form-item>

        <a-form-item
          label="奖品来源"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'prizeSource',
              { rules: [{ required: true, message: '请选择奖品来源' }] },
            ]"
            placeholder="请选择奖品来源"
            @change="prizeSourceHandle"
          >
            <a-select-option
              v-for="(item, index) in prizeSourceList"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="奖品" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select
            @change="handleChange"
            mode="multiple"
            id="drawPrizes"
            v-decorator="[
              'drawPrizes',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择奖品(多个奖品默认按选择顺序排序)',
                  },
                ],
              },
            ]"
            placeholder="请选择奖品(多个奖品默认按选择顺序排序)"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          v-if="showSort"
          label="排序"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="sortIndex"
            v-decorator="[
              'sort',
              { rules: [{ required: true, message: '请输入排序' }] },
            ]"
            placeholder="排序数字越小越靠前"
            type="number"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="关联产品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            id="assoProduct"
            v-decorator="['assoProduct']"
            placeholder="请选择产品(用于中奖后产品推荐展示)"
          >
            <a-select-option
              v-for="(item, index) in productList"
              :value="item.id"
              :key="index"
              >{{ item.productName }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="抽奖条件"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            @change="drawConditionChange"
            v-decorator="['drawCondition']"
            :triggerChange="true"
            placeholder="请选择抽奖条件"
            dictCode="draw_condition_type"
          />
        </a-form-item>
        <a-form-item
          v-if="showCondition1"
          label="抽奖条件配置值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="['drawCondition1Value']"
            placeholder="请选择积分"
          >
            <a-select-option
              v-for="(item, index) in prizesListCon"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item
          v-if="showCondition2"
          label="抽奖条件配置值"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="drawCondition2Value"
            v-decorator="['drawCondition2Value']"
            placeholder="请设置消耗抽奖次数"
            type="number"
          />
        </a-form-item>
        <a-form-item
          v-if="showCondition2"
          label="初始化次数(每人天)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :min="0"
            :step="1"
            onkeyup="this.value=this.value.replace(/\D|^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/\D|^-1/g,'')"
            id="drawInitNum"
            v-decorator="['drawInitNum']"
            placeholder="请设置初始化次数(每人天)"
            type="number"
          />
        </a-form-item>

        <a-form-item
          v-if="!showSort"
          label="每人总中奖次数限制"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="number"
            :min="0"
            onkeyup="this.value=this.value.replace(/^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/^-1/g,'')"
            id="personDayLimit"
            v-decorator="['personTotalLimit']"
            placeholder="请输入每人总中奖次数限制(不输入即无限制)"
          ></a-input>
        </a-form-item>
        <a-form-item
          v-if="!showSort"
          label="中奖频率类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            v-decorator="['prizeFrequencyType']"
            :triggerChange="true"
            placeholder="请选择中奖频率类型"
            dictCode="prize_frequency_type"
          />
        </a-form-item>
        <a-form-item
          v-if="!showSort"
          label="频率值(次)"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="number"
            :min="0"
            onkeyup="this.value=this.value.replace(/^-1/g,'')"
            onafterpaste="this.value=this.value.replace(/^-1/g,'')"
            id="prizeFrequencyValue"
            v-decorator="['prizeFrequencyValue']"
            placeholder="请输入中奖频率值(不输入即无限制)"
          ></a-input>
        </a-form-item>

        <a-form-item
          label="中奖概率"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input-number
            :default-value="prizeProbability"
            :min="0"
            :max="100"
            :formatter="(value) => `${value}%`"
            :parser="(value) => value.replace('%', '')"
            v-model="prizeProbability"
          />
        </a-form-item>

        <a-form-item
          label="是否必中奖"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-switch
            checked-children="是"
            un-checked-children="否"
            v-model="winFlag"
            @change="changeWinFlag"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import JImageUpload from '@/components/jeecg/JImageUpload';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'DrawPrizeModuleModal',
  components: {
    JMultiSelectTag,
    JDate,
    JImageUpload,
    UploadImage,
  },
  data() {
    return {
      fileList: '',
      winFlag: false,
      prizeProbability: '100', //默认中奖概率
      productList: [],
      prizesList: [], //奖品列表
      prizesListCon: [], //积分专属集合
      showSort: false, //默认不显示排序配置，仅当关联的奖品只有一个时才显示
      showCondition1: false,
      showCondition2: false,
      prizeSourceList: [
        {
          name: '奖品库',
          value: '1',
        },
        {
          name: '积分库',
          value: '2',
        },
      ], //奖品来源

      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/draw/prize/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/draw/prize/edit',
        getPrizeList:
          process.env.VUE_APP_CMS_MARKETING + '/market/prize/getPrizeList',
        getIntegralList:
          process.env.VUE_APP_CMS_MARKETING +
          '/integral/manage/getIntegralList',
        getProductList:
          process.env.VUE_APP_CMS_MARKETING + '/product/getProductList',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.fileList = '';
      this.edit({});
    },

    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;

      if (this.model.prizeProbability) {
        this.prizeProbability = this.model.prizeProbability;
      } else {
        this.prizeProbability = '100';
      }

      if (this.model.drawCondition === '1') {
        this.showCondition1 = true;
        this.showCondition2 = false;
      } else if (this.model.drawCondition === '2') {
        this.showCondition1 = false;
        this.showCondition2 = true;
      } else {
        this.showCondition1 = false;
        this.showCondition2 = false;
      }

      if (this.model.winFlag === 1) {
        this.winFlag = true;
      } else {
        this.winFlag = false;
      }

      if (this.model.drawPrizes) {
        var arr = this.model.drawPrizes.split(',');
        this.model.drawPrizes = arr;
        if (arr.length === 1) {
          this.showSort = true;
        } else {
          this.showSort = false;
        }
      } else {
        this.showSort = false;
      }

      if (record.drawImage) {
        this.fileList = record.drawImage;
      }
      this.getPrizesListCon();
      this.getProductList();
      this.prizeSourceHandle(this.model.prizeSource);

      this.$nextTick(() => {
        this.form.setFieldsValue({
          drawImage: record.drawImage
            ? process.env.VUE_APP_FILE_PATH + record.drawImage
            : '',
        });
        this.form.setFieldsValue(
          pick(
            this.model,
            'assoProduct',
            'winFlag',
            'drawInitNum',
            'drawCondition',
            'drawCondition1Value',
            'drawCondition2Value',
            'personTotalLimit',
            'prizeFrequencyType',
            'prizeFrequencyValue',
            'sort',
            'drawName',
            'drawDescribe',
            'channelType',
            // 'drawImage',
            'prizeProbability',
            'prizeSource',
            'drawPrizes'
          )
        );
      });
    },

    close() {
      this.$emit('close');
      this.visible = false;
    },

    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }
          let formData = Object.assign(this.model, values);
          formData.prizeProbability = this.prizeProbability;
          if (this.showSort === false) {
            formData.sort = '';
          } else {
            formData.personTotalLimit = '';
            formData.prizeFrequencyType = '';
            formData.prizeFrequencyValue = '';
            //formData.drawCondition = '';
            //formData.drawCondition1Value = '';
            //formData.drawCondition2Value = '';
          }
          formData.drawPrizes = formData.drawPrizes.join(',');
          formData.winFlag = that.winFlag === true ? '1' : '0';
          formData.drawImage = this.fileList;
          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },

    handleCancel() {
      this.close();
    },

    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'assoProduct',
          'winFlag',
          'drawInitNum',
          'drawCondition',
          'drawCondition1Value',
          'drawCondition2Value',
          'personTotalLimit',
          'prizeFrequencyType',
          'prizeFrequencyValue',
          'sort',
          'drawName',
          'drawDescribe',
          'channelType',
          'drawImage',
          'prizeProbability',
          'prizeSource',
          'drawPrizes'
        )
      );
    },

    prizeSourceHandle(e) {
      this.form.setFieldsValue({
        //《=关键 清空tag选项
        drawPrizes: [],
      });
      this.prizesList = [];
      if (e === '1' || e === '2') {
        this.getPrizesList(e);
      }
    },

    /**获取奖品列表*/
    getPrizesList(type) {
      let getUrl = '';
      if (type === '1') {
        getUrl = this.url.getPrizeList;
      } else if (type === '2') {
        getUrl = this.url.getIntegralList;
      } else {
        return;
      }
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
          if (type === '2') {
            this.prizesList.forEach((item) => {
              item.prizesName = item.name;
            });
          }
          console.log(this.prizesList);
        }
      });
    },

    handleChange(e) {
      if (e.length === 1) {
        this.showSort = true;
      } else {
        this.showSort = false;
      }
    },

    drawConditionChange(e) {
      if (e === '1') {
        //积分
        this.showCondition1 = true;
        this.showCondition2 = false;
      } else if (e === '2') {
        //抽奖次数
        this.showCondition2 = true;
        this.showCondition1 = false;
      } else {
        this.showCondition1 = false;
        this.showCondition2 = false;
      }
    },

    /**获取产品列表*/
    getProductList() {
      getAction(this.url.getProductList).then((res) => {
        if (res.success) {
          this.productList = res.result;
        }
      });
    },

    /**获取积分列表*/
    getPrizesListCon() {
      getAction(this.url.getIntegralList).then((res) => {
        if (res.success) {
          this.prizesListCon = res.result;
          this.prizesListCon.forEach((item) => {
            item.prizesName = item.name;
          });
        }
      });
    },

    changeWinFlag(e) {
      this.winFlag = e;
    },
    handleImageList(fileList) {
      this.fileList = fileList.fileName;
      console.log(fileList);
      this.form.setFieldsValue({
        drawImage: process.env.VUE_APP_FILE_PATH + fileList.fileName,
      });
    },
  },
};
</script>
